export default __webpack_public_path__ + "static/media/28.7c9684be.png";